export default __webpack_public_path__ + "static/media/logout.cfb51045.svg";